module.exports = __webpack_public_path__ + "static/img/logoKFC.5610b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoKFC.png
// module id = 2eEk
// module chunks = 0